export default "__VITE_ASSET__Djohwq2$__"